var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from "react";
import { DebugLog } from "../HelperFunctions";
import "./LogIn.css";
import { PasswordReset } from "./PasswordReset";
import { Icon } from "react-icons-kit";
import { eyeOff } from "react-icons-kit/feather";
import { eye } from "react-icons-kit/feather";
import axios from "axios";
export const LogInView = (props) => {
    const submitDisabled = useRef(false);
    const [resettingPW, setResettingPW] = useState(false);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [inputError, setInputError] = useState(false);
    const errorMessage_Email = useRef("");
    const errorMessage_Password = useRef("");
    const emailMessageClasses = useRef("");
    const passwordMessageClasses = useRef("");
    const fullBarMessageClasses = useRef("");
    const [isLoadingLogin, setLoadingLogin] = useState(false);
    const [loadingMessage, setLoadingMessage] = useState("Loading");
    const timing = useRef(false);
    const [type, setType] = useState("password");
    const [logInAnimClass, setLogInAnimClass] = useState("logInInputs_StartAnim");
    const [passwordResetBtnAnimClass, setPWResetAnimClass] = useState("forgotPasswordButton_StartAnim");
    const [submitBtn_AnimClass, setSubmitBtn_AnimClass] = useState("submitButton_StartAnim");
    const [submitHighlight_AnimClass, setSubmitHighlight_AnimClass] = useState("submitButtonHighlight_StartAnim");
    const [emailOutlineClass, setEmailOutlineClass] = useState("outlineWhite");
    const [passwordOutlineClass, setPasswordOutlineClass] = useState("outlineWhite");
    const emailInput = document.getElementById("emailInput");
    const passwordInput = document.getElementById("passwordInput");
    const loginErrorPopup_ID = "LogIn_ErrorContainer";
    const whiteOutlineClass = "outlineWhite";
    const redOutlineClass = "outlineRed";
    // Check autofill and fill in username & password if used
    // ** Necessary since onChange not called by autofill **
    setTimeout(() => {
        if (emailInput === null || emailInput === void 0 ? void 0 : emailInput.matches(":autofill")) {
            setEmail(emailInput.value ? emailInput.value : "");
        }
        if (passwordInput === null || passwordInput === void 0 ? void 0 : passwordInput.matches(":autofill")) {
            setPassword(passwordInput.value ? passwordInput.value : "");
        }
    }, 500);
    const BlurLogic = (e) => {
        const inputValue = e.target.value;
        if (inputValue === "") {
            e.target.value = e.target.defaultValue;
        }
    };
    const FocusLogic = (e) => {
        const inputValue = e.target.value;
        if (inputValue === e.target.defaultValue) {
            e.target.value = "";
        }
    };
    const SetEmail = (e) => {
        setEmail(e.target.value);
        setEmailOutlineClass(whiteOutlineClass);
        resetError();
    };
    const SetPassword = (e) => {
        setPassword(e.target.value);
        setPasswordOutlineClass(whiteOutlineClass);
        resetError();
    };
    const Submit = () => __awaiter(void 0, void 0, void 0, function* () {
        setInputError(false);
        if (emailInput === null ||
            !emailInput.validity.valid ||
            emailInput.value === "") {
            popupError("Invalid Email Input", true);
            setEmailOutlineClass(redOutlineClass);
        }
        else if (passwordInput.value.length === 0) {
            popupError("Invalid Password Input", false);
            setPasswordOutlineClass(redOutlineClass);
        }
        else if (!submitDisabled.current) {
            submitDisabled.current = true;
            setLoadingLogin(true);
            const logInResponse = yield props.LogIn(email, password);
            setLoadingLogin(false);
            if (logInResponse === "success") {
                startEndAnimations();
            }
            else if (logInResponse === "timeout") {
                popupError("Server Timed Out - Try Again Later", true, true);
                submitDisabled.current = false;
            }
            else if (logInResponse === "poo") {
                popupError("Unknown Response", true, true);
                submitDisabled.current = false;
            }
            else if (logInResponse === "invalid") {
                popupError("Incorrect Username/Password", true, true);
                submitDisabled.current = false;
            }
            else if (logInResponse === "unverified") {
                popupError("Account Not Verified", true, true);
                submitDisabled.current = false;
            }
            else if (logInResponse === "noAccess") {
                popupError("Account not authorized to access configurator", true, true);
                submitDisabled.current = false;
            }
            else {
                popupError("Invalid Credentials", true);
                submitDisabled.current = false;
            }
        }
    });
    const popupError = (errorMSG, isEmail, fullBar = false) => {
        emailMessageClasses.current =
            isEmail && !fullBar ? "logInBar_AnimIn_Email" : "";
        passwordMessageClasses.current =
            !isEmail && !fullBar ? "logInBar_AnimIn_Password" : "";
        fullBarMessageClasses.current = fullBar ? "logInBar_AnimIn_FullBar" : "";
        errorMessage_Email.current = isEmail ? errorMSG : "";
        errorMessage_Password.current = !isEmail ? errorMSG : "";
        setInputError(true);
        setTimeout(() => {
            var _a;
            (_a = document.getElementById(loginErrorPopup_ID)) === null || _a === void 0 ? void 0 : _a.focus();
        }, 50);
    };
    const resetError = () => {
        setTimeout(() => {
            setInputError(false);
        }, 300);
    };
    useEffect(() => {
        if (timing.current)
            return;
        timing.current = true;
        setTimeout(() => {
            timing.current = false;
            switch (loadingMessage) {
                case "Loading":
                    setLoadingMessage("Loading.");
                    break;
                case "Loading.":
                    setLoadingMessage("Loading..");
                    break;
                case "Loading..":
                    setLoadingMessage("Loading...");
                    break;
                case "Loading...":
                    setLoadingMessage("Loading");
                    break;
            }
        }, 650);
    }, [loadingMessage]);
    const startEndAnimations = () => {
        // replace animation classes
        setLogInAnimClass("logInInputs_EndAnim");
        setPWResetAnimClass("forgotPasswordButton_EndAnim");
        setSubmitBtn_AnimClass("submitButton_EndAnim");
        setSubmitHighlight_AnimClass("submitButtonHighlight_EndAnim");
    };
    const SummonPWResetComponent = () => {
        setInputError(false);
        setResettingPW(true);
    };
    const SubmitPWReset = (emailForReset) => __awaiter(void 0, void 0, void 0, function* () {
        if (emailForReset !== "") {
            try {
                const options = {
                    method: "POST",
                    headers: {
                        "Access-Control-Allow-Headers": "Content-Type",
                        "Access-Control-Allow-Origin": "*",
                        "Access-Control-Allow-Methods": "POST",
                        "Content-Type": "application/json",
                    },
                    data: emailForReset,
                };
                const url = process.env.REACT_APP_API + "/Login/ForgotPassword";
                yield axios(url, options).then((res) => {
                    const status = res.status;
                    if (status === 200) {
                        DebugLog("Succesfully Reset Password");
                    }
                    else {
                        DebugLog("Password was not reset");
                    }
                });
            }
            catch (err) {
            }
        }
        setTimeout(() => {
            setResettingPW(false);
        }, 200);
    });
    const togglePasswordVisibility = () => {
        setType(type === "password" ? "text" : "password");
    };
    const stuff = (_jsxs(_Fragment, { children: [resettingPW && (_jsx(PasswordReset, { EmailAddress: email, Submit: SubmitPWReset })), isLoadingLogin && _jsx("div", { id: "loadingLogin" }), _jsx("div", Object.assign({ id: "logInContainer" }, { children: _jsxs("div", Object.assign({ id: "logInDiv" }, { children: [inputError && (_jsxs("a", Object.assign({ href: "", id: "LogIn_ErrorContainer", className: "ErrorContainer", style: { color: "#747474" } }, { children: [_jsx("img", { id: "logInBar_message_email", className: emailMessageClasses.current, src: "./Images/LogIn/LogInBar_Message.png", alt: "ErrorMessage_BGImg" }), _jsx("img", { id: "logInBar_message_password", className: passwordMessageClasses.current, src: "./Images/LogIn/LogInBar_Message.png", alt: "ErrorMessage_BGImg" }), _jsx("img", { id: "logInBar_message_fullBar", className: fullBarMessageClasses.current, src: "./Images/LogIn/LogInBar_Message.png", alt: "ErrorMessage_BGImg" }), _jsx("span", Object.assign({ id: "span_message_email" }, { children: errorMessage_Email.current })), _jsx("span", Object.assign({ id: "span_message_password" }, { children: errorMessage_Password.current }))] }))), _jsx("div", Object.assign({ className: "mask_logInInputs" }, { children: _jsxs("div", Object.assign({ id: "logInInputs", className: logInAnimClass }, { children: [_jsx("img", { id: "logInBar", src: "./Images/LogIn/LogInBar.webp", alt: "BottomBar" }), _jsx("div", { id: "email_outline", className: emailOutlineClass }), _jsx("div", { id: "password_outline", className: passwordOutlineClass }), _jsx("input", { id: "emailInput", className: "textInputs", type: "email", placeholder: "EMAIL ADDRESS", onChange: (e) => SetEmail(e), onFocus: (e) => FocusLogic(e), onBlur: (e) => BlurLogic(e) }), _jsx("input", { id: "passwordInput", className: "textInputs", type: type, placeholder: "PASSWORD", onChange: (e) => SetPassword(e), onFocus: (e) => {
                                            FocusLogic(e);
                                        }, onBlur: (e) => BlurLogic(e) }), _jsx("button", Object.assign({ id: "password-visibility-button", "aria-label": "password visibility toggle", onClick: togglePasswordVisibility }, { children: _jsx(Icon, { id: "pw-icon", icon: type === "password" ? eyeOff : eye }) }))] })) })), _jsx("button", Object.assign({ id: "submitButton", "aria-label": "Submit", className: submitBtn_AnimClass, onClick: Submit }, { children: _jsx("img", { src: "./Images/LogIn/Submit_Image.png", alt: "", style: {
                                    position: "absolute",
                                    width: "101%",
                                    height: "100%",
                                    left: "-1%",
                                    bottom: "0%",
                                    backgroundColor: "black",
                                } }) })), _jsx("img", { id: "submitButtonHighlight", className: submitHighlight_AnimClass, src: "./Images/LogIn/Submit_Image_Highlight.png", alt: "Submit" }), isLoadingLogin && (_jsx("img", { id: "submitButtonNoText", alt: "Submit", src: "./Images/LogIn/Submit_Image_NoText.png" })), isLoadingLogin && _jsx("span", Object.assign({ id: "loadingText" }, { children: loadingMessage })), _jsx("button", Object.assign({ id: "forgotPasswordButton", className: passwordResetBtnAnimClass, onClick: SummonPWResetComponent }, { children: _jsx("span", Object.assign({ id: "fpw_span" }, { children: "Forgot Password" })) }))] })) }))] }));
    return stuff;
};
